import React from 'react';
import ChannelContext from '../ChannelContext';
import { StructuredData } from './StructuredData';
/** Renders structured product data using Schema.org vocab */
const StructuredProductData = ({ product, extraFields = {} }) => {
    var _a, _b, _c, _d;
    const { selectedChannel: { currency, url } } = React.useContext(ChannelContext);
    const baseProductData = {
        '@context': 'https://schema.org',
        '@type': 'Product',
        name: product.name,
        image: product.images.map(image => image.url || image.sizes[0].url),
        description: product.description,
        mpn: product.articleNumber,
        sku: product.articleNumber,
        productID: product.articleNumber,
        category: (_a = product.canonicalCategory) === null || _a === void 0 ? void 0 : _a.name,
        offers: {
            '@type': 'Offer',
            priceCurrency: currency.id,
            price: (_b = product.price) === null || _b === void 0 ? void 0 : _b.incVat,
            url: url + ((_c = product.primaryRoute) === null || _c === void 0 ? void 0 : _c.path),
            availability: (((_d = product.stockStatus) === null || _d === void 0 ? void 0 : _d.buyable) ? 'http://schema.org/InStock'
                : 'http://schema.org/OutOfStock')
        }
    };
    const withInjectedProductData = Object.assign(Object.assign({}, baseProductData), extraFields);
    return React.createElement(StructuredData, { json: withInjectedProductData });
};
export { StructuredProductData };
//# sourceMappingURL=StructuredProductData.js.map